<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
<!--                <el-form label-position="top">-->
<!--                    <el-form-item label="筛选仓库">-->
<!--                        <el-select v-model="filter.shopName" placeholder="仓库"-->
<!--                                   clearable-->
<!--                                   filterable remote-->
<!--                                   :remote-method="handelSearchStore"-->
<!--                                   @change="handleIndexShop()">-->
<!--                            <el-option-->
<!--                                    v-for="item in warehouses"-->
<!--                                    :key="item.id"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.id">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
<!--                </el-form>-->
                <div>
                    <el-button size="mini" @click="handleStoreWarehouse()">创建仓库</el-button>
                </div>
                <div>
                    <el-button size="mini" @click="handleGetWarehouse()">查看仓库</el-button>
                </div>
            </div>
        </div>
        <div class="m-portlet right m-b-0">

            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <div>
                    <el-button size="mini" @click="handleStoreShopName()">新增商品</el-button>
                </div>
                <el-table v-if="!loading"
                          :data="orderShopNames"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-40"
                          size="middle">
                    <el-table-column prop="id" label="ID" min-width="5%"></el-table-column>
                    <el-table-column prop="name" label="设备名" min-width="10%"> </el-table-column>
                    <el-table-column prop="price" label="价格" min-width="10%"> </el-table-column>
                    <el-table-column prop="return_day" label="可租赁天数" min-width="10%"> </el-table-column>
                    <el-table-column prop="free_day" label="免租日" min-width="10%"> </el-table-column>
                    <el-table-column prop="daily_rent" label="日租金" min-width="10%"> </el-table-column>
                    <el-table-column prop="statusName" label="状态" min-width="10%"> </el-table-column>
                    <el-table-column label="操作" min-width="10%">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleStudentInformation(scope.row.id,scope.row.name)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "students-list",
        data() {
            return {
                path: '/student/list',
                loading: true,
                shopNames: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                filter:{
                    storeId: 1,
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleIndexShop();
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderShopNames: function () {
                return this._.orderBy(this.shopNames, 'id', 'asc');
            }
        },
        methods: {
            handleIndexShop(currentPage=1) {
                this.loading=true;
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$axios.get(store.state.server + '/getShopName?'+
                    'storeId='+this.filter.storeId +
                    '&studentId='+this.filter.studentId +
                    '&page='+this.currentPage +
                    '&limit=' + this.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.loading=false;
                        if (Object.keys(response.data.content.list).length !== 0) {
                            this.shopNames=response.data.content.list
                        } else {
                            this.shopNames = new Object();
                        }
                        this.total=response.data.content.total
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleStudentInformation(nameId, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/warehouse/shopMsgList/' + nameId,
                    'closable': true
                });
                this.router.push({path: '/warehouse/shopMsgList/' + nameId})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexShop(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexShop(this.currentPage)
            },
            handleStoreShopName(){
                this.$Win.openModal('Dialogs_StoreShopName', 400, 400, '创建商品');
            },
            handleStoreWarehouse(){
                this.$Win.openModal('Dialogs_StoreWarehouse', 400, 400, '创建仓库');
            },
            handleGetWarehouse(){
                this.$Win.openModal('Dialogs_GetWarehouse', 400, 400, '仓库列表');
            }

        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
